export const en = {
    'create-by': 'Use as template',
    'create-tooltip': 'No more than 30 negative keywords sets may be added',
    'create-tooltip-disabled': 'No permission to create a set',
    delete: 'Delete',
    'delete-tooltip': 'Unlink the set of negative keywords before deleting',
    'delete-tooltip-disabled': 'No permission to delete the set',
    edit: 'Edit',
    'editable-tooltip': 'No permission to configure the set'
};
